document.addEventListener("DOMContentLoaded", () => {
  try {

    import ("../../common/index");

    console.log("DOMContentLoaded, on single template page");
  } catch (error) {
    console.error("An error occurred while loading the files on single template page", error);
  }
});
